import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { calculateCartSubTotal } from 'features/cart/utils';
import { StyleSheet, Text } from 'react-native';

import { Footer } from 'components/ui/footer';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

import { CartFooterDiscountOffer } from './cart-footer-discount-offer';

export const CartFooter = () => {
  const { cartEntries } = useMinimalCart();
  const subTotal = calculateCartSubTotal(cartEntries);
  const { formatCurrencyForLocale } = useUIContext();
  return (
    <Footer style={styles.footer}>
      <CartFooterDiscountOffer />
      <Text style={styles.text}>Subtotal: {formatCurrencyForLocale(subTotal)}</Text>
    </Footer>
  );
};

const styles = StyleSheet.create({
  footer: {
    paddingVertical: 0,
    paddingHorizontal: 0,
    width: '100%',
    flex: 1,
    flexDirection: 'column',
    gap: 8,
  },
  text: {
    fontSize: 19,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
});
